import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { FC, ReactNode } from 'react';

import { Box, SxProps } from '@mui/system';

type SortableItemProps = {
  id: string;
  children: ReactNode;
};

const SortableItem: FC<SortableItemProps> = (props) => {
  const {
    isDragging,
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
  } = useSortable({ id: props.id });

  const inlineStyles: SxProps = {
    'opacity': isDragging ? '0.9' : '1',
    'transform': CSS.Transform.toString(transform),
    'backgroundColor': 'transparent',
    'transition': transition,
    'zIndex': isDragging ? 'tooltip' : 0,

    '& > *': isDragging
      ? {
          boxShadow: 10,
          cursor: 'grabbing',
        }
      : null,
  };

  return (
    <Box
      ref={setNodeRef}
      sx={inlineStyles}
      {...props}
      {...attributes}
      {...listeners}
    >
      {props.children}
    </Box>
  );
};

export default SortableItem;
